var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { Card } from "../../components/modules/Card";
import { Text } from "../../components/elements/Text";
import { Button } from "../../components/elements/Button";
import Character from "../../../images/personagem-tentativas-excedidas.png";
import { ButtonContainer, Container, ContentContainer, ImageContainer, InfoContainer, Wrapper, } from "./styles";
export function TooManyRequest() {
    return (_jsx(Container, { children: _jsx(Wrapper, { children: _jsx(Card, { children: _jsx(ContentContainer, { children: _jsxs(InfoContainer, { children: [_jsx(ImageContainer, { src: Character }), _jsx(Box, __assign({ marginBottom: "2rem" }, { children: _jsx(Text, __assign({ textStyle: "subtitle1", color: "fakeBlack" }, { children: "Tentativas Excedidas" })) })), _jsx(Box, __assign({ marginBottom: "2rem" }, { children: _jsx(Text, __assign({ textStyle: "body1", color: "fakeBlack" }, { children: "Sua conta foi bloqueada. Para efetuar o desbloqueio, entre em contato com a nossa Central de Ajuda." })) })), _jsx(ButtonContainer, __assign({ id: "help-center" }, { children: _jsx(Button, { href: "https://123milhas--tst1.custhelp.com/app/ajuda", children: "IR PARA A CENTRAL DE AJUDA", buttonVariant: "h2", colorScheme: "gradient" }) }))] }) }) }) }) }));
}
